import { render, staticRenderFns } from "./ColumnLayerInner.vue?vue&type=template&id=68c36d33"
var script = {}
import style0 from "./ColumnLayerInner.vue?vue&type=style&index=0&id=68c36d33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports